<div class="modal-header">
  <button type="button" (click)="onClickClose()" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
  <div class="centered title">
    <span class="icon dica-foto" style="padding-left: 50px; padding-bottom: 35px"></span>
    <h4 class="modal-title">{{ titulo }}!</h4>
  </div>
  
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-xs-12 text-modal">
      <p>Precisa de ajuda para tirar as melhores fotos? Confira algumas dicas abaixo:</p>
      
      <div style="display:flex">
     
        <div style="display: flex;">
          <span class="icon dica-ambiente lined"></span>
          <div>
              <h4>Ambiente iluminado</h4>
              <p>Um ambiente bem iluminado proporciona fotos melhores.</p>
          </div>
        </div>
     
        <div style="display: flex">
          <span class="icon dica-horizontal lined"></span>
          <div>
              <h4>Prefira fotos na horizontal</h4>
              <p>Essa escolha lhe dará mais opções de enquadramento do documento.</p>
          </div>
        </div>

      </div>

      <div style="display:flex">
        <div style="display: flex">
            <span class="icon dica-nitida lined"></span>
              <div>
                <h4>Foto nítida</h4>
                <p>Toque na tela para marcar o ponto de foco e verifique se sua foto está nítida antes de enviar.</p>
              </div>
        </div>

        <div style="display:flex">
            <span class="icon dica-flash lined"></span>
            <div>
              <h4>Evite utilizar o flash</h4>
              <p>O flash acabará prejudicando as suas fotos, deixando as cores mais artificiais e adicionando reflexos desnecessários.</p>
            </div>
        </div>  
      </div>

    <div>
        <div style="display:flex">
            <span class="icon dica-zoom lined"></span>
            <div>
              <h4>Evite dar zoom</h4>
               <p>Na maioria dos casos, o zoom diminui a qualidade da foto e acaba prejudicando a sua nitidez e enquadramento.</p>
            </div>
        </div>
    </div>

    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="centered">
      <button *ngIf="showFecharBtn" type="button" class="btn btn-border-orange pull-left" (click)="onClickClose()">{{ labelFechar }}</button>
  </div>
</div>